export const defaultViewport = {   // Default viewport (California boundary)   
    latitude: 37.57131,
    longitude: -117.02523,
    zoom: 5.13
}